import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  ButtonBase,
  Tabs,
  Tab,
  makeStyles,
} from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Joi from 'joi';
import moment from 'moment';
import {
  AutocompleteComponent,
  DatePickerComponent,
  Inputs,
  Spinner,
  SwitchComponent,
  SelectComponet,
} from '../../../../Components';
import { ActivityFilesUploader } from '../../../../Components/UploaderActivitieFileComponent/ActivityFilesUploader';
import { getErrorByName, showError, showSuccess, showWarn } from '../../../../Helper';
import {
  OrganizationUserSearch,
  CreateActivity,
  GetAllReplyActivityType,
  GetAllSystemTemplateByCategoryId,
  leadDetailsGet,
  contactsDetailsGet,
} from '../../../../Services';
import { GetActivityTypeById } from '../../../../Services/ActivitiesTypesServices';
import { ActivtityRemindersTab } from '../../../../SharedComponents/ActivitiesManagementDialog/ActivtityRemindersTab';
import { ActivityNotificationsTab } from '../../../../SharedComponents/ActivitiesManagementDialog/ActivityNotificationsTab';
import { ActivityRelatedToInput } from '../../../../SharedComponents/ActivitiesManagementDialog/ActivityRelatedToInput';
import { TemplateCategoryEnum } from '../../../../Enums';
import { config } from '../../../../config';

export const ReplyActivityDialog = ({
  activeItem,
  onSave,
  parentTranslationPath,
  translationPath,
  open,
  close,
  isGeneralDialog,
}) => {
  const { t } = useTranslation([parentTranslationPath, 'Shared']);
  const durationTypes = [
    { key: 1, value: 'minutes', momentKey: 'minutes' },
    { key: 2, value: 'hours', momentKey: 'hours' },
    { key: 3, value: 'days', momentKey: 'days' },
  ];
  const allowedActivityTypeIds = [config.RejectWithCounterProposal, config.PriceNegotiationApproved, config.PriceNegotiationRejected];
  const { pathname } = useLocation();
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const reminderAmountOfTimeTypes = [
    { key: 1, value: 'minutes', momentKey: 'minutes' },
    { key: 2, value: 'hours', momentKey: 'hours' },
    { key: 3, value: 'days', momentKey: 'days' },
  ];
  const isSaleActivitiesView = pathname.includes('activities-sales');
  const isLeaseActivitiesView = pathname.includes('activities-lease');
  const isContactCenterActivitiesView = pathname.split('/home/')[1] === 'Activities';
  const isLeadActivitiesView = pathname.includes('lead-profile-edit');
  const isMortgageActivitiesView = pathname.includes('activities-mortgage');
  const isUnitActivitiesView = pathname.includes('unit');
  const isContactActivitiesView = pathname.includes('contact-profile-edit');
  const isLeadOwnerActivitiesView = pathname.includes('lead-owner-activity');

  const [StateOriginalPrice, setStateOriginalPrice] = useState(0);
  const [StateProposedPrice, setStateProposedPrice] = useState('');

  const reducer = useCallback((state, action) => {
    if (action.id !== 'edit') return { ...state, [action.id]: action.value };
    return { ...action.value };
  }, []);

  const useStyles = makeStyles((theme) => ({
    root: { padding: '0px', paddingBottom: '5px', textTransform: 'initial' },
    indicator: { backgroundColor: 'var(--c-primary)' },
    labelIcon: { minHeight: 'unset' },
    wrapper: { display: 'flex', alignItems: 'flex-start', flexDirection: 'row' },
    fixed: { width: 'fit-content', margin: 'auto' },
    scroller: { flex: 'unset' },
  }));
  const classes = useStyles();
  const searchTimer = useRef(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [LeadId, setLeadId] = useState(false);
  const [isEditDialog, setIsEditDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isWithReminder, setIsWithReminder] = useState();
  const [withDateTime, setwithDateTime] = useState(true);
  const [activityRelatedToList, setActivityRelatedToList] = useState([]);
  const [isRelatedToNotSelected, setIsRelatedToNotSelected] = useState(true);
  const [defaultReminders, setDefaultReminders] = useState(null);
  const [filter] = useState({ pageIndex: 0, pageSize: 25 });
  const [tabIndex, setTabIndex] = useState(0);
  const [rols, setrols] = useState([]);
  const [loadings, setLoadings] = useReducer(reducer, {
    activityAssignments: false,
    activityTypes: false,
  });
  const [remindersWithoutEmptyItems, setRemindersWithoutEmptyItems] = useState([]);
  const [selected, setSelected] = useReducer(reducer, {
    activityAssign: null,
    activityType: null,
    relatedUnit: null,
    relatedLead: null,
    relatedContact: null,
    relatedPortfolio: null,
    relatedWorkOrder: null,
    relatedMaintenanceContract: null,
    reminderForOptions: [],
    reminderTypeOptions: [],
    durationType: 1,
    durationAmount: 0,
  });
  const [data, setData] = useReducer(reducer, {
    activityAssignments: [],
    activityTypes: [],
    reminderTemplates: [],
    relatedLead: [],
    relatedContact: [],
    relatedUnit: [],
    relatedPortfolio: [],
    relatedWorkOrder: [],
    relatedMaintenanceContract: [],
  });
  const [state, setState] = useReducer(reducer, {
    assignAgentId: null,
    activityTypeId: null,
    relatedUnitNumberId: null,
    relatedLeadNumberId: null,
    relatedContactNumberId: null,
    relatedActivityToId: null,
    relatedPortfolioId: null,
    relatedWorkOrderId: null,
    relatedMaintenanceContractId: null,
    activityDate: moment().add(2, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
    activityEndDate: null,
    activityDuration: null,
    subject: null,
    comments: null,
    price: null,
    isApproved: false,
    isRejected: false,
    isRejectedWithCounterProposal: false,
    isOpen: true,
    activityReminders: [],
    createdByName: (loginResponse && loginResponse.fullName) || null,
  });


  const getTimeValue = (item) => {
    if (!state.activityDate) return 0;
    const currentTimeAmountType = reminderAmountOfTimeTypes.find(
      (items) => items.key === (item.reminderAmountOfTimeType || 1)
    );
    return moment(state.activityDate).diff(item.reminderTime, currentTimeAmountType.momentKey);
  };

  const handleTabClick = (event, newValue) => {
    setTabIndex(newValue);
  };

  const getAllActivityAssignments = useCallback(
    async (value) => {
      setLoadings({ id: 'activityAssignments', value: true });
      const res = await OrganizationUserSearch({
        ...filter,
        rolesIds: rols,
        name: (value && value.value) || '',
      });
      if (!(res && res.status && res.status !== 200)) {
        setData({ id: 'activityAssignments', value: (res && res.result) || [] });
      } else {
        setData({ id: 'activityAssignments', value: [] });
      }
      setLoadings({ id: 'activityAssignments', value: false });
    },
    [filter, rols]
  );

  const getAllSystemTemplateByCategoryId = useCallback(async () => {
    setLoadings({ id: 'reminderTemplates', value: true });
    const res = await GetAllSystemTemplateByCategoryId(TemplateCategoryEnum.Activity.key);
    if (!(res && res.status && res.status !== 200)) {
      const mappedTempatesData = res?.map((item) => ({
        templateName: item.systemTemplateName,
        templateId: item.systemTemplateId,
      }));
      setData({ id: 'reminderTemplates', value: mappedTempatesData || [] });
    } else {
      setData({ id: 'reminderTemplates', value: [] });
    }
    setLoadings({ id: 'reminderTemplates', value: false });
  }, []);

  const handleActivityRelatedToList = (relatedTo) => {
    if (relatedTo) {
      let filteredRelatedTo = [];
      if (
        isGeneralDialog ||
        isContactCenterActivitiesView ||
        isLeadOwnerActivitiesView ||
        isSaleActivitiesView ||
        isLeaseActivitiesView ||
        isLeadActivitiesView
      ) {
        filteredRelatedTo = relatedTo;
      } else if (isContactActivitiesView) {
        filteredRelatedTo = relatedTo.filter(
          (item) => item.relatedToName === 'Contact' || item.relatedToName === 'Lead'
        );
      } else if (isUnitActivitiesView) {
        filteredRelatedTo = relatedTo.filter(
          (item) =>
            item.relatedToName === 'Lead' ||
            item.relatedToName === 'Unit' ||
            item.relatedToName === 'Contact'
        );
      } else if (isMortgageActivitiesView) {
        filteredRelatedTo = relatedTo.filter(
          (item) => item.relatedToName === 'Lead' || item.relatedToName === 'Contact'
        );
      }
      setActivityRelatedToList(filteredRelatedTo || []);
    } else {
      setActivityRelatedToList([]);
    }
  };

  const getActivityTypeById = useCallback(async () => {
    setLoadings({ id: 'activityTypes', value: true });
    if (selected.activityType !== null) {
      const res = await GetActivityTypeById(state.activityTypeId);
      if (!(res && res.status && res.status !== 200)) {
        setIsWithReminder(res.withReminder);
        setwithDateTime(res.withDateTime);
        setDefaultReminders(res.activityTypeReminders);
        handleActivityRelatedToList(res.relatedTo);
      } else {
        setIsWithReminder(res.withReminder);
        setwithDateTime(res.withDateTime);
      }
    }
    setLoadings({ id: 'activityTypes', value: false });
  }, [state.activityTypeId]);

  const getContactDetails = useCallback(async (contactId) => {
    setLoadings({ id: 'relatedContact', value: true });
    const res = await contactsDetailsGet({ id: contactId });
    if (!(res && res.status && res.status !== 200)) {
      setSelected({ id: 'relatedContact', value: res });
    } else {
      setSelected({ id: 'relatedContact', value: null });
    }
    setLoadings({ id: 'relatedContact', value: false });
  }, []);

  const getRelatedLeadDetails = useCallback(
    async (leadId) => {
      setLoadings({ id: 'relatedLead', value: true });
      const res = await leadDetailsGet({ id: leadId });
      if (!(res && res.status && res.status !== 200)) {
        setSelected({ id: 'relatedLead', value: res });
        if (selected.activityAssign) {
          const reminderForOptions = [
            { id: selected.activityAssign?.id, value: selected.activityAssign?.fullName, type: 'agent' },
            { id: res.leadId, value: res?.lead?.contact_name?.name, type: 'lead' },
          ];
          setSelected({ id: 'reminderForOptions', value: reminderForOptions });
        }
      }
      setLoadings({ id: 'relatedLead', value: false });
    },
    [selected.activityAssign]
  );

  const getAllActivityTypes = useCallback(async () => {
    setIsLoading(true);
    setLoadings({ id: 'activityTypes', value: true });
    const res = await GetAllReplyActivityType(activeItem && activeItem.activityTypeId);
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: 'activityTypes', value: res || [] });
    } else {
      setData({ id: 'activityTypes', value: [] });
    }
    setLoadings({ id: 'activityTypes', value: false });
    setIsLoading(false);
  }, [activeItem]);

  const reminderTimeCalculateHandler = useCallback(
    (item, value, type, activityDate) => {
      const currentTimeAmountType = reminderAmountOfTimeTypes.find(
        (items) => items.key === (type || item.reminderAmountOfTimeType || 1)
      );
      let newTimeValue = moment(activityDate || state.activityDate)
        .add(-value, currentTimeAmountType.momentKey)
        .format('YYYY-MM-DDTHH:mm:ss');
      if (moment(newTimeValue).isBefore(moment().format('YYYY-MM-DDTHH:mm:ss'))) {
        newTimeValue = null;
      }
      setState({ id: 'activityReminders', value: state.activityReminders });
      return newTimeValue;
    },
    [reminderAmountOfTimeTypes, state.activityDate, state.activityReminders]
  );

  const activityTimeChangeHandler = (activityDate) => {
    if (state.activityReminders) {
      const mappedActiveItemReminders = state.activityReminders.map((item) => ({
        ...item,
        reminderTime: reminderTimeCalculateHandler(
          item,
          getTimeValue(item) || 0,
          item.reminderAmountOfTimeType,
          activityDate
        ),
      }));
      setState({ id: 'activityReminders', value: mappedActiveItemReminders });
    }
  };

  const handleReminderForAgentOptions = (newValue) => {
    let itemToPush = {};
    const localReminderForOptions = [...selected.reminderForOptions];
    const assignToReminderIndex = localReminderForOptions.findIndex(
      (item) => item.type === 'agent'
    );
    if (newValue) {
      itemToPush = {
        id: newValue.id,
        value: newValue.fullName,
        type: 'agent',
      };
    }
    if (!newValue && assignToReminderIndex !== -1) {
      localReminderForOptions.splice(assignToReminderIndex, 1);
    }
    if (newValue && assignToReminderIndex !== -1) {
      localReminderForOptions[assignToReminderIndex] = itemToPush;
    }
    if (newValue && assignToReminderIndex === -1) {
      localReminderForOptions.push(itemToPush);
    }
    setSelected({ id: 'reminderForOptions', value: localReminderForOptions });
  };

  const checkIsRelatedLeadClosed = () => {
    const relatedLeadStatus = selected?.relatedLead?.lead?.status?.lookupItemName;
    return activeItem?.relatedLeadNumberId && relatedLeadStatus === 'Closed';
  };

  const calculateDurationAmount = (previousType, newType) => {
    const durationTypeKey = durationTypes[previousType - 1].momentKey;
    const momentFormatDuration = moment.duration(selected.durationAmount, durationTypeKey);
    let newDurationAmount = 0;
    if (newType === 1) newDurationAmount = Math.floor(momentFormatDuration.asMinutes());
    if (newType === 2) newDurationAmount = Math.floor(momentFormatDuration.asHours());
    if (newType === 3) newDurationAmount = Math.floor(momentFormatDuration.asDays());
    setSelected({ id: 'durationAmount', value: newDurationAmount });
  };

  const calculateActivityEndDate = () => {
    if (state.activityDate && state.activityDuration) {
      const endDate = moment(state.activityDate)
        .add(state.activityDuration, 'minutes')
        .format('YYYY-MM-DDTHH:mm:ss');
      setState({ id: 'activityEndDate', value: endDate });
    } else {
      setState({ id: 'activityEndDate', value: null });
    }
  };

  const calculateDurationInMinutes = () => {
    if (selected.durationAmount) {
      const durationTypeKey = durationTypes[selected.durationType - 1].momentKey;
      const momentFormatDuration = moment.duration(selected.durationAmount, durationTypeKey);
      const durationInMinutes = momentFormatDuration.asMinutes();
      setState({ id: 'activityDuration', value: durationInMinutes });
    } else {
      setState({ id: 'activityDuration', value: null });
    }
  };

  const extractPriceFromComments = (comments) => {
    if (!comments) {
      return { originalPrice: null, proposedPrice: null };
    }
    const originalPriceMatch = comments.match(/Original Rental Price: (\d+\.?\d*)/i);
    const proposedPriceMatch = comments.match(/Proposed Rental Price: (\d+\.?\d*)/i);
    return {
      originalPrice: originalPriceMatch ? Number(originalPriceMatch[1]) : null,
      proposedPrice: proposedPriceMatch ? Number(proposedPriceMatch[1]) : null,
    };
  };

  const schema = Joi.object({
    assignAgentId: Joi.string()
      .required()
      .messages({
        'string.base': t(`${translationPath}activity-assign-to-is-required`),
      }),
    activityTypeId: Joi.number()
      .required()
      .messages({
        'number.base': t(`${translationPath}activity-type-is-required`),
        'any.required': t(`${translationPath}activity-type-is-required`),
      }),
    relatedUnitNumberId: Joi.any(),
    relatedLeadNumberId: Joi.any(),
    relatedContactNumberId: Joi.any(),
    relatedPortfolioId: Joi.any(),
    relatedWorkOrderId: Joi.any(),
    relatedMaintenanceContractId: Joi.any(),
    relatedFields: Joi.any().custom((value, helpers) => {
      const {
        relatedUnitNumberId,
        relatedLeadNumberId,
        relatedContactNumberId,
        relatedPortfolioId,
        relatedWorkOrderId,
        relatedMaintenanceContractId,
      } = helpers.state.ancestors[0];
      if (
        isRelatedToNotSelected &&
        !relatedUnitNumberId &&
        !relatedLeadNumberId &&
        !relatedContactNumberId &&
        !relatedPortfolioId &&
        !relatedWorkOrderId &&
        !relatedMaintenanceContractId
      ) {
        return helpers.error('state.required');
      }
      return value;
    }).messages({
      'state.required': t(`${translationPath}related-to-is-required-one-at-least`),
    }),
    activityDate: Joi.when(Joi.ref('$activeItem'), {
      is: null,
      then: Joi.when(Joi.ref('$withDateTime'), {
        is: true,
        then: Joi.date()
          .required()
          .greater(Date.now())
          .messages({
            'date.base': t(`${translationPath}activity-date-is-required`),
            'date.greater': t(`${translationPath}choose-time-after-now`),
          }),
        otherwise: Joi.any(),
      }),
      otherwise: Joi.any(),
    }),
    activityReminders: Joi.when(Joi.ref('$isWithReminder'), {
      is: true,
      then: Joi.when(Joi.ref('$remindersWithoutEmptyItems.length'), {
        is: Joi.number().greater(0),
        then: Joi.array().items(
          Joi.object({
            reminderType: Joi.any().required(),
            leadId: Joi.any(),
            usersId: Joi.any(),
            reminderTime: Joi.any(),
            templateId: Joi.any().required(),
          }).custom((value, helpers) => {
            if (!value.leadId && !value.usersId) {
              return helpers.error('state.userNotSet');
            }
            if ((value.reminderTime && getTimeValue(value)) || 0 === 0) {
              return helpers.error('state.timeIsZero');
            }
            if (!value.templateId) {
              return helpers.error('state.emptyTemplateId');
            }
            if (!value.reminderType) {
              return helpers.error('state.reminderType');
            }
            return value;
          }).messages({
            'state.userNotSet': t(`${translationPath}reminder-for-is-required`),
            'state.timeIsZero': t(`${translationPath}time-must-be-greater-than-zero`),
            'state.emptyTemplateId': t(`${translationPath}reminder-template-is-required`),
            'state.reminderType': t(`${translationPath}reminder-type-is-required`),
          })
        ),
        otherwise: Joi.any(),
      }),
      otherwise: Joi.any(),
    }),
    price: Joi.when(Joi.ref('activityTypeId'), {
      is: config.RejectWithCounterProposal,
      then: Joi.number()
        .required()
        .messages({
          'number.base': t(`${translationPath}price-is-required`),
        }),
      otherwise: Joi.any(),
    }),
  })
    .options({ abortEarly: false, allowUnknown: true })
    .validate(state, {
      context: {
        activeItem,
        withDateTime,
        isWithReminder,
        remindersWithoutEmptyItems,
      },
    });

  const saveHandler = async (event) => {
    setIsSubmitted(true);
    event.preventDefault();
    if (withDateTime === true && !activeItem) {
      if (!state.activityDate) {
        showError(t(`${translationPath}choose-time-after-now`));
        setIsLoading(false);
        return;
      }
    }

    if (schema?.error?.message) {
      showError(t(`${translationPath}${schema.error.message}`));
      return;
    }

    const saveState = { ...state };
    const filteredReminders = saveState.activityReminders.filter(
      (item) => (item.usersId || item.leadId) && item.reminderType && item.templateId && item.reminderTime
    );
    const mappedReminders = filteredReminders.map((item) => {
      const contactId = item.leadId ? selected.relatedLead?.lead?.contact_name?.id : null;
      return {
        activityReminderId: item.activityReminderId,
        reminderType: item.reminderType,
        reminderTime: item.reminderTime,
        templateId: item.templateId,
        usersId: item.usersId,
        contactId,
      };
    });
    saveState.activityReminders = mappedReminders;

    setIsLoading(true);
    const res = activeItem && activeItem.activityId && (await CreateActivity(saveState));
    setIsLoading(false);
    if (!(res && res.status && res.status !== 200)) {
      showSuccess(t(`${translationPath}activity-created-successfully`));
      if (onSave) onSave();
    } else {
      showError(t(`${translationPath}activity-create-failed`));
    }
  };

  useEffect(() => {
    calculateDurationInMinutes();
    calculateActivityEndDate();
  }, [selected.durationAmount, selected.durationType, state.activityDate, state.activityDuration]);

  useEffect(() => {
    if (activeItem && activeItem.relatedLeadNumberId) {
      getRelatedLeadDetails(activeItem.relatedLeadNumberId);
    }
  }, [activeItem, selected.activityAssign]);

  useEffect(() => {
    if (activeItem && activeItem.relatedContactNumberId) {
      getContactDetails(activeItem.relatedContactNumberId);
    }
  }, [activeItem]);

  useEffect(() => {
    if (state.activityTypeId) {
      getActivityTypeById();
      getAllActivityAssignments();
    }
  }, [state.activityTypeId]);

  useEffect(() => {
    if (activeItem) getAllActivityTypes();
    getAllSystemTemplateByCategoryId();
  }, [activeItem]);

  useEffect(() => {
    if (activeItem && !selected.relatedContact) {
      const relatedContactData =
        data.relatedContact &&
        data.relatedContact.find((item) => activeItem.relatedContactNumberId === item.contactsId);
      const relatedContact =
        relatedContactData && activeItem.relatedContactNumberId
          ? {
            contactsId: activeItem.relatedContactNumberId,
            contact: {
              company_name: relatedContactData?.contact?.company_name || '',
              first_name: relatedContactData?.contact?.first_name || '',
              last_name: relatedContactData?.contact?.last_name || '',
            },
          }
          : null;
      setSelected({ id: 'relatedContact', value: relatedContact });
    }
  }, [activeItem, data.relatedContact, state.relatedContactNumberId]);


  useEffect(() => {
    if (activeItem) {
      const relatedUnit = activeItem.relatedUnitNumberId
        ? {
          id: activeItem.relatedUnitNumberId,
          propertyName: activeItem.relatedUnitPropertyName,
          unitRefNo: activeItem.unitReferenceNo,
        }
        : null;
      const relatedMaintenanceContract = activeItem.relatedMaintenanceContractId
        ? { maintenanceContractId: activeItem.relatedMaintenanceContractId }
        : null;
      const relatedPortfolio = activeItem.relatedPortfolioId
        ? {
          portfolioId: activeItem.relatedPortfolioId,
          portfolioName: activeItem.relatedPortfolioName,
        }
        : null;
      setSelected({
        id: 'edit',
        value: {
          ...selected,
          relatedUnit,
          relatedPortfolio,
          relatedMaintenanceContract,
        },
      });
    }
  }, [activeItem]);

  useEffect(() => {
    let assignAgent = null;
    if (allowedActivityTypeIds.includes(state.activityTypeId)) {
      if (activeItem?.createdById && activeItem?.createdByName) {
        assignAgent = {
          id: activeItem.createdById,
          fullName: activeItem.createdByName,
        };
        setState({ id: 'assignAgentId', value: activeItem?.createdById });
      }
      if (assignAgent) {
        setSelected({ id: 'activityAssign', value: assignAgent });
        setState({ id: 'assignAgentId', value: assignAgent.id });
        handleReminderForAgentOptions(assignAgent);
      }
    }
  }, [activeItem, state.activityTypeId, loginResponse]);

  useEffect(() => {
    if (state.activityTypeId === config.RejectWithCounterProposal && +state.price > +StateOriginalPrice) {
      showWarn(t(`${translationPath}proposed-price-not-lower`, 'Proposed price is not lower than original'));
    }
     else     if (state.activityTypeId === config.RejectWithCounterProposal && +state.price === +StateOriginalPrice) {
          showWarn(
            t(
              `${translationPath}You-are-proposing-the-same-price-as-the-original.-Please-confirm-this-is-intentional`,
              'You are proposing the same price as the original. Please confirm this is intentional'
            )
          );
        }
  }, [state.price, StateOriginalPrice]);


 

  useEffect(() => {
    const proposedPrice = StateProposedPrice || 'N/A';
    const unitId = selected.relatedUnit?.unitRefNo || selected.relatedUnit?.id || 'N/A';
    const leadId = selected.relatedLead?.leadId || 'N/A';
    let comment = state.comments || '';

    if ( state.activityTypeId === config.PriceNegotiationApproved) {
      comment = `The proposed price of ${proposedPrice} for Unit ${unitId} linked to Lead ${leadId} has been approved.`;
    } else if ( state.activityTypeId === config.RejectWithCounterProposal) {
      comment = `The proposed price of ${proposedPrice} for Unit ${unitId} linked to Lead ${leadId} has been rejected. However, a counter offer has been proposed at ${state.price || 'N/A'}.`;
    } else if ( state.activityTypeId === config.PriceNegotiationRejected) {
      comment = `The proposed price of ${proposedPrice} for Unit ${unitId} linked to Lead ${leadId} has been rejected.`;
    } else if (
      state.activityTypeId !== config.PriceNegotiationApproved &&
      state.activityTypeId !== config.RejectWithCounterProposal &&
      state.activityTypeId !== config.PriceNegotiationRejected
    ) {
      comment = '';
    }

    setState({ id: 'comments', value: comment });
  }, [state.activityTypeId, StateProposedPrice, selected.relatedUnit, selected.relatedLead, state.price]);

  useEffect(() => {
    const { originalPrice, proposedPrice } = extractPriceFromComments(activeItem?.comments || '');
    setStateOriginalPrice(originalPrice !== null ? originalPrice.toString() : '');
    setStateProposedPrice(proposedPrice !== null ? proposedPrice.toString() : '');
    const { activityTypeId, price: currentPrice } = state;
    const isApproved = activityTypeId === config.PriceNegotiationApproved;
    const isRejected = activityTypeId === config.PriceNegotiationRejected;
    const isRejectedWithCounterProposal = activityTypeId === config.RejectWithCounterProposal;

    let finalPrice = null;
    if (isRejectedWithCounterProposal) {
      finalPrice = +currentPrice || 0;
    } else if (isApproved) {
      finalPrice = +StateProposedPrice;
    }

    setState({
      id: 'edit',
      value: {
        ...state,
        isApproved,
        isRejected,
        isRejectedWithCounterProposal,
        price: finalPrice,
      },
    });
  }, [state.activityTypeId, activeItem?.comments]);
  
  useEffect(() => {
    if (activeItem) {
      setState({
        id: 'edit',
        value: {
          ...state,
          relatedActivityToId: activeItem.activityId,
          relatedLeadNumberId: activeItem.relatedLeadNumberId || null,
          relatedUnitNumberId: activeItem.relatedUnitNumberId || null,
          relatedContactNumberId: activeItem.relatedContactNumberId || null,
          relatedPortfolioId: activeItem.relatedPortfolioId || null,
          relatedWorkOrderId: activeItem.relatedWorkOrderId || null,
          relatedMaintenanceContractId: activeItem.relatedMaintenanceContractId || null,
        },
      });
    }
  }, [activeItem]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => close()}
        className='activities-management-dialog-wrapper'
      >
        <Spinner isActive={isLoading} isAbsolute />
        <form noValidate onSubmit={saveHandler}>
          <DialogTitle id='alert-dialog-slide-title'>
            {t(`${translationPath}add-activity-reply`)}
          </DialogTitle>
          <DialogContent>
            <Tabs
              value={tabIndex}
              onChange={handleTabClick}
              aria-label='icon label tabs'
              textColor='primary'
              classes={{ indicator: classes.indicator, scroller: classes.scroller, fixed: classes.fixed }}
            >
              <Tab
                classes={{ root: classes.root, wrapper: classes.wrapper, labelIcon: classes.labelIcon }}
                icon={<span className='mr-2 mdi mdi-format-list-checks' />}
                label={t(`${translationPath}Details`)}
              />
              <Tab
                classes={{ root: classes.root, wrapper: classes.wrapper, labelIcon: classes.labelIcon }}
                icon={<span className='mr-2 mdi mdi-file-document' />}
                label={t(`${translationPath}Attachments`)}
              />
              <Tab
                classes={{ root: classes.root, wrapper: classes.wrapper, labelIcon: classes.labelIcon }}
                icon={<span className='mr-2 mdi mdi-alarm-check' />}
                label={t(`${translationPath}Reminders`)}
              />
              {activeItem && (
                <Tab
                  classes={{ root: classes.root, wrapper: classes.wrapper, labelIcon: classes.labelIcon }}
                  icon={<span className='mr-2 mdi mdi-bell' />}
                  label={t(`${translationPath}Notifications`)}
                />
              )}
            </Tabs>
            {tabIndex === 0 && (
              <div className='dialog-content-wrapper'>
                <div className='dialog-content-item'>
                  <AutocompleteComponent
                    idRef='activityTypeIdRef'
                    labelValue='activity-type'
                    labelClasses='Requierd-Color'
                    selectedValues={selected.activityType}
                    multiple={false}
                    isDisabled={isEditDialog}
                    data={data.activityTypes}
                    displayLabel={(option) => option.activityTypeName || ''}
                    groupBy={(option) => option.categoryName || ''}
                    getOptionSelected={(option) => option.activityTypeId === state.activityTypeId}
                    withoutSearchButton
                    helperText={getErrorByName(schema, 'activityTypeId').message}
                    error={getErrorByName(schema, 'activityTypeId').error}
                    isLoading={loadings.activityTypes}
                    isWithError
                    isSubmitted={isSubmitted}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    onChange={(event, newValue) => {
                      setState({ id: 'activityTypeId', value: (newValue && newValue.activityTypeId) || null });
                      setSelected({ id: 'activityType', value: newValue });
                      setState({ id: 'subject', value: (newValue && newValue.activityTypeName) || null });

                      allowedActivityTypeIds.includes(newValue && newValue.activityTypeId) &&
                        setState({
                          id: 'assignAgentId',
                          value: (activeItem && activeItem.assignedToId) || null,
                        });



                      const assignedToActivityTypeRoles = (newValue && newValue.assignedToActivityTypeRoles) || [];
                      const rolesIds = assignedToActivityTypeRoles?.map((item) => item.rolesId || []);
                      setrols(rolesIds);
                      setSelected({ id: 'reminderForOptions', value: [] });
                    }}
                  />
                </div>
                <div className='dialog-content-item'>
                  <AutocompleteComponent
                    idRef='assignAgentIdRef'
                    labelValue='activity-assign-to'
                    labelClasses='Requierd-Color'
                    selectedValues={selected.activityAssign}
                    multiple={false}
                    isDisabled={state.activityTypeId == null}
                    data={data.activityAssignments}
                    displayLabel={(option) => option.fullName || ''}
                    renderOption={(option) =>
                      ((option.userName || option.fullName) && `${option.fullName} (${option.userName})`) || ''
                    }
                    getOptionSelected={(option) => option.id === state.assignAgentId}
                    withoutSearchButton
                    helperText={getErrorByName(schema, 'assignAgentId').message}
                    error={getErrorByName(schema, 'assignAgentId').error}
                    isLoading={loadings.activityAssignments}
                    onKeyDown={() => setSelected({ id: 'activityAssign', value: null })}
                    onInputKeyUp={(e) => {
                      const onSearch = e.target;
                      if (searchTimer.current) clearTimeout(searchTimer.current);
                      searchTimer.current = setTimeout(() => {
                        getAllActivityAssignments(onSearch);
                      }, 700);
                    }}
                    isWithError
                    isSubmitted={isSubmitted}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    onChange={(event, newValue) => {
                      setSelected({ id: 'activityAssign', value: newValue });
                      setState({ id: 'assignAgentId', value: (newValue && newValue.id) || null });
                      handleReminderForAgentOptions(newValue);
                    }}
                  />
                </div>
                <ActivityRelatedToInput
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  activityRelatedToList={activityRelatedToList}
                  setIsRelatedToNotSelected={setIsRelatedToNotSelected}
                  isSubmitted={isSubmitted}
                  isReplyDialog
                  isWithReminder={isWithReminder}
                  activeItem={activeItem}
                  schema={schema}
                  state={state}
                  setState={setState}
                  selected={selected}
                  setSelected={setSelected}
                  setLeadId={setLeadId}
                  data={data}
                  setData={setData}
                  isGeneralDialog={isGeneralDialog}
                  checkIsRelatedLeadClosed={checkIsRelatedLeadClosed}
                />
                {withDateTime && (
                  <div className='dialog-content-item'>
                    <DatePickerComponent
                      idRef='activityDateRef'
                      labelClasses='Requierd-Color'
                      labelValue='activity-date'
                      placeholder='DD/MM/YYYY'
                      value={state.activityDate || moment().format('YYYY-MM-DDTHH:mm:ss')}
                      helperText={getErrorByName(schema, 'activityDate').message}
                      error={getErrorByName(schema, 'activityDate').error}
                      isSubmitted={isSubmitted}
                      minDate={
                        !activeItem
                          ? moment().format('YYYY-MM-DDTHH:mm:ss')
                          : activeItem?.createdOn
                            ? moment(activeItem.createdOn).format('YYYY-MM-DDTHH:mm:ss')
                            : ''
                      }
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onDateChanged={(newValue) => {
                        const activityDateValue =
                          (newValue && moment(newValue).format('YYYY-MM-DDTHH:mm:ss')) ||
                          moment().add(2, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
                        setState({ id: 'activityDate', value: activityDateValue });
                        if (activeItem) activityTimeChangeHandler(activityDateValue);
                        if (!activeItem) setState({ id: 'activityReminders', value: [] });
                      }}
                    />
                  </div>
                )}
                {withDateTime && (
                  <div className='dialog-content-item'>
                    <DatePickerComponent
                      idRef='activityTimeRef'
                      labelValue='activity-time'
                      labelClasses='Requierd-Color'
                      isTimePicker
                      value={
                        state.activityDate || moment().add(2, 'minutes').format('YYYY-MM-DDTHH:mm:ss')
                      }
                      helperText={getErrorByName(schema, 'activityDate').message}
                      error={getErrorByName(schema, 'activityDate').error}
                      isSubmitted={isSubmitted}
                      minDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onDateChanged={(newValue) => {
                        setState({
                          id: 'activityDate',
                          value: (newValue && moment(newValue).format('YYYY-MM-DDTHH:mm:ss')) || null,
                        });
                        if (activeItem) activityTimeChangeHandler(newValue ? moment(newValue).format('YYYY-MM-DDTHH:mm:ss') : null);
                        if (!activeItem) setState({ id: 'activityReminders', value: [] });
                      }}
                    />
                  </div>
                )}
                {withDateTime && (
                  <div className='dialog-content-item'>
                    <Inputs
                      idRef='activityDurationIdRef'
                      labelValueWithoutTranslation={
                        state.activityEndDate && state.activityDuration
                          ? `Duration (ends by ${moment(state.activityEndDate).format('L')} ${moment(state.activityEndDate).format('LT')})`
                          : `Duration`
                      }
                      value={selected.durationAmount}
                      isDisabled={!state.activityDate}
                      wrapperClasses='mb-0'
                      endAdornment={
                          <SelectComponet
                            idRef='durationTypeIdRef'
                            data={durationTypes}
                            value={selected.durationType}
                            valueInput='key'
                            textInput='value'
                            onSelectChanged={(newType) => {
                              const previousType = selected.durationType;
                              setSelected({ id: 'durationType', value: newType });
                              calculateDurationAmount(previousType, newType);
                            }}
                            wrapperClasses='over-input-select w-auto'
                            parentTranslationPath={parentTranslationPath}
                            translationPath={translationPath}
                            translationPathForData={translationPath}
                          />
                      }
                      type='number'
                      min={0}
                      isWithError
                      isSubmitted={isSubmitted}
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      onInputChanged={(event) => {
                        const { value } = event.target;
                        const roundedValue = Math.ceil(+value);
                        setSelected({ id: 'durationAmount', value: roundedValue });
                      }}
                    />
                  </div>
                )}
                <div className='dialog-content-item'>
                  <Inputs
                    idRef='stageRef'
                    labelValue='stage'
                    value={
                      (selected.activityType && selected.activityType.leadStageName) ||
                      t(`${translationPath}not-contacted`)
                    }
                    isDisabled
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                  />
                </div>
                {selected.activityType && (
                  <>
                    <div className='dialog-content-item'>
                      <Inputs
                        idRef='leadRatingRef'
                        labelValue='lead-rating'
                        value={selected.activityType.leadRatingName}
                        isDisabled
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                      />
                    </div>
                    <div className='dialog-content-item'>
                      <Inputs
                        idRef='leadQualificationRef'
                        labelValue='lead-qualification'
                        value={selected.activityType.leadQualificationName}
                        isDisabled
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                      />
                    </div>
                  </>
                )}
                <div className='dialog-content-item'>
                  <Inputs
                    idRef='subjectRef'
                    labelValue='subject'
                    value={state.subject || ''}
                    helperText={getErrorByName(schema, 'subject').message}
                    error={getErrorByName(schema, 'subject').error}
                    isWithError
                    isDisabled
                    isSubmitted={isSubmitted}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    onInputChanged={(event) => {
                      setState({ id: 'subject', value: event.target.value });
                    }}
                  />
                </div>
                <div className='dialog-content-item'>
                  <Inputs
                    idRef='created-byRef'
                    labelValue='created-by'
                    value={state.createdByName || ''}
                    isDisabled
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                  />
                </div>
                {state.activityTypeId === config.RejectWithCounterProposal && (
                  <>
                    <div className='dialog-content-item'>
                      <Inputs
                        idRef='OriginalPriceRef'
                        labelValue='Original Price'
                        value={StateOriginalPrice || ''}
                        disabled
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                      />
                    </div>
                    <div className='dialog-content-item'>
                      <Inputs
                        idRef='ProposedPriceRef'
                        labelValue='Proposed Price'
                        value={StateProposedPrice || ''}
                        disabled
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                      />
                    </div>
                    <div className='dialog-content-item'>
                      <Inputs
                        idRef='priceRef'
                        labelValue='Counter Proposed Price'
                        value={state.price ?? ''}
                        helperText={getErrorByName(schema, 'price').message}
                        error={getErrorByName(schema, 'price').error}
                        isWithError
                        isSubmitted={isSubmitted}
                        type='number'
                        min={0}
                        parentTranslationPath={parentTranslationPath}
                        translationPath={translationPath}
                        onInputChanged={(event) => {
                          setState({
                            id: 'price',
                            value: event.target.value ? Number(event.target.value) : null,
                          });
                        }}
                      />
                    </div>
                  </>
                )}
                <div className='dialog-content-item'>
                  <SwitchComponent
                    idRef='isOpenStatusRef'
                    isChecked={state.isOpen}
                    themeClass='theme-line'
                    labelValue={(state.isOpen && 'open') || 'closed'}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    onChangeHandler={(event, isChecked) =>
                      setState({ id: 'isOpen', value: isChecked })
                    }
                  />
                </div>
                <div className='dialog-content-item w-100'>
                  <Inputs
                    idRef='commentsRef'
                    labelValue='comments'
                    value={state.comments || ''}
                    helperText={getErrorByName(schema, 'comments').message}
                    error={getErrorByName(schema, 'comments').error}
                    isWithError
                    isSubmitted={isSubmitted}
                    multiline
                    rows={4}
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    onInputChanged={(event) => {
                      setState({ id: 'comments', value: event.target.value });
                    }}
                  />
                </div>
              </div>
            )}
            {tabIndex === 1 && (
              <div className='dialog-content-item w-100'>
                <ActivityFilesUploader
                  state={state}
                  setState={setState}
                  activeItem={activeItem}
                  isReplyDialog
                  initFilesChangeAllowed={false}
                />
              </div>
            )}
            {tabIndex === 2 && (
              <div className='px-5 pt-3 w-100'>
                <ActivtityRemindersTab
                  activeItem={activeItem}
                  schema={schema}
                  state={state}
                  setState={setState}
                  selected={selected}
                  defaultReminders={defaultReminders}
                  loadings={loadings}
                  setSelected={setSelected}
                  data={data}
                  setRemindersWithoutEmptyItems={setRemindersWithoutEmptyItems}
                  isSubmitted={isSubmitted}
                  isWithReminder={isWithReminder}
                  isReplyDialog
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                />
              </div>
            )}
            {tabIndex === 3 && activeItem && (
              <ActivityNotificationsTab
                filter={filter}
                translationPath={translationPath}
                parentTranslationPath={parentTranslationPath}
                activeItem={activeItem}
              />
            )}
          </DialogContent>
          <DialogActions>
            <ButtonBase onClick={() => close()} className='btns theme-solid bg-cancel'>
              {t(`${translationPath}cancel`)}
            </ButtonBase>
            <ButtonBase
              className='btns theme-solid'
              type='submit'
              disabled={checkIsRelatedLeadClosed()}
            >
              {t(`${translationPath}save`)}
            </ButtonBase>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};